export default __webpack_public_path__ + "static/media/contactwavetop.f17da5f2.png";